/**
 * @generated SignedSource<<12f973126bc31545387575cbaa32a3a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentUsageBrainSearchButtonFragment$data = {
  readonly content: {
    readonly type: ContentType;
  };
  readonly id: string;
  readonly " $fragmentType": "ContentUsageBrainSearchButtonFragment";
};
export type ContentUsageBrainSearchButtonFragment$key = {
  readonly " $data"?: ContentUsageBrainSearchButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentUsageBrainSearchButtonFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentUsageBrainSearchButtonFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "7016ea375b72d40dab26e0d3e963496c";

export default node;
